<template>
  <div class="container_PPersonalizeTable">
    <div class="containerItems_PPersonalizeTable">
      <div class="item_PPersonalizeTable">
        <div class="fieldsTitle_PPersonalizeTable" v-if="fieldsTitle != ''">{{ fieldsTitle }}</div>
        <div class="fields_PPersonalizeTable">
          <div
            v-for="(checkField, index_checks) in valueLocalComp"
            :key="index_checks + checkField.label + 'div'"
          >
            <div class="fieldsTitle_PPersonalizeTable" v-if="mostrarTitulo(index_checks)">
              {{ checkField.groupField }}
            </div>
            <p-form-check-box
              :id="index_checks + checkField.label"
              v-model="checkField.show"
              :label="checkField.label"
              @change="changeCheck(checkField)"
            ></p-form-check-box>
          </div>
        </div>
      </div>
      <div class="item_PPersonalizeTable">
        <div class="orderTitle_PPersonalizeTable">{{ orderTitle }}</div>
        <div class="order_PPersonalizeTable">
          <p-drag-and-drop
            id="dragAndDrop_PPersonalizeTable"
            v-model="valueLocalOrderComp"
          ></p-drag-and-drop>
        </div>
      </div>
    </div>

    <div class="buttons_PPersonalizeTable">
      <p-button id="restore_buttons_PPersonalizeTable" variant="link" @click="restore">
        {{ bRestoreText }}
      </p-button>
      <p-button id="apply_buttons_PPersonalizeTable" variant="primary" @click="aplicar">
        {{ bApplyText }}
      </p-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PFormCheckBox from "../PFormCheckBox/PFormCheckBox.vue";
import PDragAndDrop from "../PDragAndDrop/PDragAndDrop.vue";
import PButton from "../PButton/PButton.vue";
import { FieldPTableType } from "./pTable.type";

@Component({
  components: {
    PFormCheckBox,
    PDragAndDrop,
    PButton,
  },
})
export class PPersonalizeTable extends Vue {
  @Prop({ required: true }) value!: FieldPTableType[];
  @Watch("value", { deep: true, immediate: true })
  onChangeValue(): void {
    this.value.forEach((fi: FieldPTableType) => {
      this.valueLocalOrder.push({ ...fi });
    });
  }
  @Prop({ required: true }) initFiels!: FieldPTableType[];
  @Watch("initFiels", { deep: true, immediate: true })
  onChangeInitFiels(): void {
    this.groupFields = [];
    this.initFiels.forEach((fi: FieldPTableType) => {
      this.valueLocal.push({ ...fi });

      this.groupFields.push(fi.groupField); //esto esta hecho porque hay un error de infinito no solucionable
    });
  }
  @Prop({ required: false, default: "Resetear" }) bRestoreText!: string;
  @Prop({ required: false, default: "Aplicar" }) bApplyText!: string;
  @Prop({ required: false, default: "" }) fieldsTitle!: string;
  @Prop({ required: false, default: "Orden de columnas:" }) orderTitle!: string;
  valueLocal: FieldPTableType[] = [];
  valueLocalOrder: FieldPTableType[] = []; //ojo este cambia el ordern
  rellenarValueLocalOrder = new Date().getTime();
  groupFields: string[] = [];

  get valueLocalComp(): FieldPTableType[] {
    //comprobamos los que estan visibles y los ponemos
    this.valueLocalOrder.forEach((fi) => {
      const fiTemp = this.valueLocal.find((vl) => vl.key === fi.key);
      if (fiTemp) {
        fiTemp.show = fi.show;
      }
    });
    return this.valueLocal.filter((vl) => vl.type != "action");
  }
  get valueLocalOrderComp(): FieldPTableType[] {
    let returnTemp: FieldPTableType[] = [];
    if (this.rellenarValueLocalOrder > 0) {
      //esto es solo un truco para que rellene el cambio
      returnTemp = this.valueLocalOrder.filter((fi: FieldPTableType) => fi.show);
    }
    this.rellenarValueLocalOrder = new Date().getTime();
    return returnTemp.slice(1);
  }
  set valueLocalOrderComp(value: FieldPTableType[]) {
    const accione = this.valueLocalOrder[0];
    this.valueLocalOrder = value;
    this.valueLocalOrder.unshift(accione);
  }

  mostrarTitulo(index: number): boolean {
    if (index == 0) {
      return true;
    } else return this.groupFields[index] != this.groupFields[index + 1];
  }
  restore(): void {
    this.valueLocal.forEach((fi) => {
      fi.show = true;
    });
    this.valueLocalOrder.forEach((fi) => {
      fi.show = true;
    });
  }
  aplicar(): void {
    const valueTemp: any[] = [];
    //relleno en primer lugar los primeros
    this.valueLocalOrder.forEach((fi) => {
      valueTemp.push({ ...fi });
    });
    //rellenamos los que no esten
    this.valueLocal.forEach((fi) => {
      if (valueTemp.findIndex((field) => field.key) == -1) {
        valueTemp.push({ ...fi });
      }
    });
    this.$emit("input", valueTemp);
    this.$emit("change", valueTemp);
  }
  changeCheck(field: FieldPTableType): void {
    const fieldOrder = this.valueLocalOrder.find((fi) => fi.key == field.key);
    if (fieldOrder) {
      fieldOrder.show = field.show;
      this.rellenarValueLocalOrder = new Date().getTime(); //hacemos saltar el relleno automatico
    } else {
      this.valueLocalOrder.push({ ...field });
    }
  }
}
export default PPersonalizeTable;
</script>
<style scoped>
.containerItems_PPersonalizeTable {
  display: flex;
  align-items: stretch;
  min-height: 300px;
  justify-content: space-around;
}
.container_PPersonalizeTable {
  padding: 10px;
}
.item_PPersonalizeTable {
  flex: 0 0 50%;
}
.order_PPersonalizeTable {
  padding: 10px;
  border-radius: 4px;
  border: solid 1px #e4e4e4;
  background-color: #fafafa;
  min-height: 300px;
}
.fieldsTitle_PPersonalizeTable {
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #4c4c4c;
  padding-bottom: 8px;
  margin-top: 15px;
}
.fields_PPersonalizeTable {
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  margin-top: -15px;
}
.fields_PPersonalizeTable label {
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.45;
  letter-spacing: normal;
  color: #6f6f6f;
  white-space: nowrap;
  padding: 2px 0;
}
.fields_PPersonalizeTable span {
  white-space: nowrap;
}
.orderTitle_PPersonalizeTable {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #4c4c4c;
  margin-bottom: 10px;
}
.buttons_PPersonalizeTable {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
</style>
